import React, { Fragment } from 'react';
import { Check } from 'lucide-react';
interface StepIndicatorProps {
  currentStep: 'inicial' | 'concorrentes' | 'atributos' | 'analise';
}
const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep
}) => {
  const steps = [{
    key: 'inicial',
    label: 'Informações'
  }, {
    key: 'concorrentes',
    label: 'Concorrentes'
  }, {
    key: 'atributos',
    label: 'Atributos'
  }, {
    key: 'analise',
    label: 'Relatório'
  }];
  const getStepStatus = (stepKey: string) => {
    const stepOrder = {
      inicial: 0,
      concorrentes: 1,
      atributos: 2,
      analise: 3
    };
    const currentStepIndex = stepOrder[currentStep];
    const thisStepIndex = stepOrder[stepKey];
    if (thisStepIndex < currentStepIndex) return 'completed';
    if (thisStepIndex === currentStepIndex) return 'current';
    return 'upcoming';
  };
  return <div className="mb-8" data-id="element-1236" data-mp="36k7x4ydvlwy5">
      <div className="flex items-center justify-between" data-id="element-1237" data-mp="36kzh1by4268l">
        {steps.map((step, index) => <Fragment key={step.key} data-id="element-1238" data-mp="3bz5jrqplsgzp" data-mpi={index}>
            <div className="flex flex-col items-center" data-id="element-1239" data-mp="3gy8plddeqr8q">
              <div className={`w-8 h-8 flex items-center justify-center rounded-full 
                  ${getStepStatus(step.key) === 'completed' ? 'bg-gray-400 text-white' : getStepStatus(step.key) === 'current' ? 'bg-black text-white' : 'bg-white text-gray-900 border border-gray-300'}`} data-id="element-1240" data-mp="3gwnu9lj9r49t">
                {getStepStatus(step.key) === 'completed' ? <Check size={16} data-id="element-1241" data-mp="2y0659bvt1ih9" /> : index + 1}
              </div>
              <span className={`mt-2 text-xs font-medium 
                  ${getStepStatus(step.key) === 'completed' ? 'text-gray-500' : getStepStatus(step.key) === 'current' ? 'text-gray-900' : 'text-gray-700'}`} data-id="element-1242" data-mp="323c9yf39r1lm">
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && <div className={`flex-1 h-0.5 
                  ${getStepStatus(steps[index + 1].key) === 'upcoming' ? 'bg-gray-200' : getStepStatus(steps[index].key) === 'current' ? 'bg-gray-300' : 'bg-gray-400'}`} data-id="element-1243" data-mp="2ic6y2307nfw7"></div>}
          </Fragment>)}
      </div>
    </div>;
};
export default StepIndicator;